/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type NotificationRuleTicketingToolsParamsDto = {
    templateId: string;
    type: NotificationRuleTicketingToolsParamsDto.type;
};

export namespace NotificationRuleTicketingToolsParamsDto {

    export enum type {
        JIRA = 'JIRA',
        SERVICENOW = 'SERVICENOW',
    }


}
